import { defaultLocale } from '~/i18n/config'

export const useChecks = () => {
  const isOnLandingPage = computed(() => '/' === useLocalePath()(useRoute().path, defaultLocale))
  return {
    isOnLandingPage,
  }
}
